
































import { Vue, Component } from 'vue-property-decorator';
import { loading } from '@/decorators';

@Component
export default class OrderSetting extends Vue {
  /** 数据列表 */
  private dataList: TypeOrderSetting.SettingInfoData[] = [];
  /** 请求状态 */
  private loading: boolean = true;
  /**
   * 请求列表数据
   */
  @loading('loading')
  private async querySettingsList(): Promise<void> {
    const res = await this.$api.newOrder.orderSettingList();
    this.dataList = res.data;
  }
  /**
   * 设置单个配置项
   */
  private async handeSettingsChange(index: number, subIndex: number, value: boolean): Promise<void> {
    /** 平台 */
    const item: TypeOrderSetting.SettingInfoData = this.dataList[index];
    /** 平台配置列表 */
    const configure: TypeOrderSetting.SettingListItem = item.list[subIndex];
    this.$set(configure, '_loading', true);
    configure.field_value = !value;
    const params: TypeOrderSetting.SettingInfoReq = {
      order_type: item.order_type,
      field_value: value,
      field_key: configure.field_key,
    };
    try {
      const res = await this.$api.newOrder.updateOrderSetting(params);
      configure.field_value = value;
      this.$set(configure, '_loading', false);
      this.$message.success(this.t('操作成功'));
      this.querySettingsList();
    } catch (error) {
      this.$set(configure, '_loading', false);
    }
  }
  private created() {
    this.querySettingsList();
  }

}
